import { render, staticRenderFns } from "./MatricesStudyPlan.vue?vue&type=template&id=5128b91b&scoped=true&"
import script from "./MatricesStudyPlan.vue?vue&type=script&lang=js&"
export * from "./MatricesStudyPlan.vue?vue&type=script&lang=js&"
import style0 from "./MatricesStudyPlan.vue?vue&type=style&index=0&id=5128b91b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128b91b",
  null
  
)

export default component.exports